<template>
  <div
    :class="[
      'sidebar-container ',
      { active: Sidebar },
      { ' mobile-sidebar ': getMobileSidebar }
    ]"
  >
    <div class="brand-container">
      <button
        class="btn-sidebar-toggler"
        v-on:click="toggleSidebar()"
        v-if="!isMobile"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div v-if="!isGoGoCinema">
        <img
          src="@/assets/img/logos/logo-light.png"
          height="auto"
          width="100"
          class="ml-2 c-pointer"
          @click="goHome"
        />
      </div>
      <!-- <h1 class="text-white text-center mb-0">LOGO</h1> -->
    </div>

    <div class="links-container">
      <ul class="sidebar-nav" v-if="SideNav.length > 0 && checkUpdate">
        <li
          v-for="(Nav, index) in SideNav"
          :key="index"
          v-on:click="onsidebar"
          v-if="
            Nav.hasOwnProperty('permissions') &&
              checkChildrens(index, Nav) &&
              ((Nav.name == 'My Cinemas' && isSidebarShow) ||
                Nav.name != 'My Cinemas') &&
              Nav.isChildrenExist
          "
        >
          <div v-if="Nav.children && Nav.children.length > 0">
            <div
              class="parent-nav"
              :class="Nav.isCollapsed ? null : 'collapsed'"
              :aria-expanded="Nav.isCollapsed ? 'true' : 'false'"
              :aria-controls="'parentNav-lvl-1-' + index"
              @click="onHandleCollapsed(SideNav, index)"
            >
              <div :class="Nav.icon + ' nav-icon'"></div>

              <div class="nav-title">
                {{ $tc(Nav.name, 2) }}
              </div>
            </div>

            <!-- <b-collapse
              accordion="my-accordion"
              v-model="Nav.isCollapsed"
              :id="'parentNav-' + index"
              v-if="Nav.children"
            >
              <ul class="child-nav-list">
                <li
                  v-for="(ChildNav, _index) in Nav.children"
                  v-if="
                    ChildNav.hasOwnProperty('permissions') &&
                      checkNavPermissions(
                        ChildNav.permissions,
                        ChildNav.cine_direct_sale,
                        ChildNav.module_id,
                        ChildNav
                      )
                  "
                  :key="_index"
                >
                  <router-link
                    :to="ChildNav.url"
                    @click.native="setCurrentSideNavRoute(ChildNav.url)"
                    :title="ChildNav.name"
                    :class="[
                      ' ',
                      getCurrentSideNavRoute &&
                      getCurrentSideNavRoute === ChildNav.url
                        ? 'router-link-exact-active router-link-active'
                        : ''
                    ]"
                  >
                    <div class="d-flex">
                      <img
                        src="@/assets/img/icons/arrow-right.svg"
                        height="auto"
                        width="10"
                        class="mr-2"
                      />
                      {{ $tc(ChildNav.name, 2) }}
                    </div>
                  </router-link>
                </li>
              </ul>
            </b-collapse> -->

            <sidebar-dropdown
              v-if="Nav.children"
              :index="index"
              :children="Nav.children"
              :isCollapsed="Nav.isCollapsed"
              :onHandleCollapsed="onHandleCollapsed"
            />
          </div>

          <router-link
            v-else-if="Nav.hasOwnProperty('show') ? Nav.show : true"
            :to="Nav.url"
            class="parent-nav"
          >
            <span :class="Nav.icon + ' nav-icon'"></span>
            <div class="nav-title">{{ Nav.name }}</div>
          </router-link>
        </li>
      </ul>
    </div>
    <!--
    <div class="powered-container">
      <div>
        Powered by
        <br />Binary Numbers
      </div>
    </div>-->
  </div>
</template>

<script>
/* eslint-disable */
import Nav from "@/Nav";
import { mapGetters, mapActions } from "vuex";
import { checkAccessController, checkParentId } from "@/helper/AccessControl";
// import { authenticationService } from "@/services/AuthenticationService";
import sidebarDropdown from "./sidebarDropdown.vue";
import UserService from "@/services/UserService";

export default {
  components: {
    "sidebar-dropdown": sidebarDropdown
  },
  data() {
    return {
      SideNav: Nav.items,
      Sidebar: true,
      openCollapseId: null,
      fnbactive: false,
      isSidebarShow: false,
      checkUpdate: false,
      modules: [],
      array_new_module: [],
      count: 0
    };
  },
  watch: {
    $route(to, from) {
      this.makeAllCollapseFalse();
      this.SideNav.map((x, index) => {
        this.collapseRouteCheck(x, to, x);
      });
    }
  },
  computed: {
    getGLobalOption() {
      return this.secureStore.get("MYCINEMASTATUS") || "N";
    },
    isGoGoCinema() {
      let isGogoCinema = this.$store.getters.isGogoCinema == "Y" ? true : false;
      return isGogoCinema;
    },
    ...mapGetters(["getCurrentSideNavRoute", "getMobileSidebar"]),
    isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  beforeMount() {
    let fnbvalue = this.secureStore.get("ENABLE_FNB");
    let roleid =
      this.secureStore.get("USINFO") && this.secureStore.get("USINFO").role_id
        ? this.secureStore.get("USINFO").role_id
        : null;
    // console.log("fnbvalue :", fnbvalue);
    if (roleid && roleid == 1 && fnbvalue == "N") {
      this.fnbactive = true;
    }
    this.getModuleList();
  },
  mounted() {
    setTimeout(x => {
      console.log(this.getMyCinemaStatusNew(), "UTILLLLLSSSIDEBAR");
      this.checkUpdate = true;
      this.isSidebarShow = this.getMyCinemaStatusNew() == "Y" ? true : false;
    }, 2700);
    // this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
    //   if (isJustShown) {
    //     this.openCollapseId = collapseId;
    //   }
    // });
  },
  methods: {
    makeAllCollapseFalse() {
      this.SideNav.map((x, _index) => {
        if (x.hasOwnProperty("children")) {
          x.children.map(y => {
            if (y.hasOwnProperty("children")) {
              y.children.map(z => {
                z["isCollapsed"] = false;
                x["isCollapsed"] = false;
                y["isCollapsed"] = false;
              });
            } else {
              x["isCollapsed"] = false;
              y["isCollapsed"] = false;
            }
          });
        } else {
          x["isCollapsed"] = false;
        }
      });
    },
    collapseRouteCheck(x, to, initialObj) {
      if (x.hasOwnProperty("children")) {
        x.children.map(y => {
          if (y.hasOwnProperty("children")) {
            y.children.map(z => {
              if (z.url == to.fullPath) {
                z["isCollapsed"] = true;
                y["isCollapsed"] = true;
                x["isCollapsed"] = true;
              } else {
                z["isCollapsed"] = false;
              }
            });
          } else {
            if (y.url == to.fullPath) {
              x["isCollapsed"] = true;
              y["isCollapsed"] = true;
            } else {
              y["isCollapsed"] = false;
            }
          }
        });
      } else {
        if (x.url == to.fullPath) {
          x["isCollapsed"] = true;
        } else {
          x["isCollapsed"] = false;
        }
      }
    },
    checkArrayModuleNew(x, startObj) {
      x["show"] = true;

      if (this.isGoGoCinema && x.hasOwnProperty("GogoName")) {
        x["name"] = x.GogoName;
      }
      if (this.CLIENT_SETUP_NAME && x.hasOwnProperty("only_available_on")) {
        console.log(
          x.only_available_on,
          this.CLIENT_SETUP_NAME,
          "Testttt2222222"
        );
        let checkKeyExist = x.only_available_on.filter(zzz => {
          return zzz.key_name == this.CLIENT_SETUP_NAME;
        });
        if (checkKeyExist.length > 0) {
          x["url"] = checkKeyExist[0].url;
        }
      }

      if (x.hasOwnProperty("only_visible_on")) {
        if (this.CLIENT_SETUP_NAME) {
          let checkKeyExist = x.only_visible_on.filter(ovo => {
            return ovo.key_name == this.CLIENT_SETUP_NAME;
          });

          if (checkKeyExist.length > 0) {
            x["show"] = true;
          } else {
            x["show"] = false;
          }
        } else {
          x["show"] = false;
        }
      }
      if (x.hasOwnProperty("children") && x["show"]) {
        x.children.map(y => {
          if (this.CLIENT_SETUP_NAME && y.hasOwnProperty("only_available_on")) {
            console.log(
              y.only_available_on,
              this.CLIENT_SETUP_NAME,
              "Testttt2222222"
            );
            let checkKeyExist = y.only_available_on.filter(zzz => {
              return zzz.key_name == this.CLIENT_SETUP_NAME;
            });
            if (checkKeyExist.length > 0) {
              y["url"] = checkKeyExist[0].url;
            }
          }

          if (y.hasOwnProperty("only_visible_on")) {
            if (this.CLIENT_SETUP_NAME) {
              let checkKeyExist = y.only_visible_on.filter(ovo => {
                return ovo.key_name == this.CLIENT_SETUP_NAME;
              });

              if (checkKeyExist.length > 0) {
                y["show"] = true;
              } else {
                y["show"] = false;
              }
            } else {
              y["show"] = false;
            }
          }
          if (this.isGoGoCinema && y.hasOwnProperty("GogoName")) {
            y["name"] = y.GogoName;
          }
          if (y.hasOwnProperty("children")) {
            y["isChildrenExist"] = false;
            console.log("loop Having  Children", y.name, y, this.count);
            this.checkArrayModuleNew(y, startObj);
          } else {
            let checkModule = this.modules.filter(z => {
              return z.module_id == y.module_id;
            });
            if (checkModule.length > 0) {
              if (checkModule[0].module_is_active == "Y") {
                x["show"] = true;
                y["ModuleId"] = "1";
                if (x.hasOwnProperty("isChildrenExist")) {
                  x["isChildrenExist"] = true;
                }
                startObj["isChildrenExist"] = true;
              } else {
                x["show"] = false;
                y["ModuleId"] = "2";
              }
            } else {
              y["show"] = true;
              y["ModuleId"] = "3";
            }
          }
        });
      } else if (x["show"]) {
        let checkModule = this.modules.filter(z => {
          return z.module_id == x.module_id;
        });
        if (checkModule.length > 0) {
          if (checkModule[0].module_is_active == "Y") {
            x["show"] = true;
            y["ModuleId"] = "1";
            if (x.hasOwnProperty("isChildrenExist")) {
              x["isChildrenExist"] = true;
            }
            startObj["isChildrenExist"] = true;
          } else {
            x["show"] = false;
            y["ModuleId"] = "2";
          }
        } else {
          y["show"] = true;
          y["ModuleId"] = "3";
        }
      }
    },
    checkArrayModule(x, index) {
      // let array_new=[];
      // let array_not_available=[];
      if (x.hasOwnProperty("children")) {
        let obj = {
          icon: x.icon,
          isCollapsed: x.isCollapsed,
          name: x.name,
          show: x.show,
          url: x.url,
          permissions: x.permissions,
          children: []
        };
        x.children.map((y, index1) => {
          if (y.hasOwnProperty("children")) {
            this.checkArrayModule(y, index1);
          } else {
            let checkModule = this.modules.filter(z => {
              return z.module_id == y.module_id;
            });
            if (checkModule.length > 0) {
              if (checkModule[0].module_is_active == "Y") {
                obj.children.push(y);
              }
            } else {
              obj.children.push(y);
              //  array_not_available.push(y)
            }
          }
        });
        this.array_new_module.push(obj);
      } else {
        let checkModule = this.modules.filter(z => {
          return z.module_id == x.module_id;
        });
        if (checkModule.length > 0) {
          if (checkModule[0].module_is_active == "Y") {
            this.array_new_module.push(x);
          }
        } else {
          this.array_new_module.push(x);
        }
      }
    },
    getModuleList: function() {
      let loader = this.$loading.show();
      // let loader = this.$loading.show();

      // console.log("payload :", payload);
      UserService.ModulesList()
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.modules = data.Records;
            console.log(data, "Modukes", this.SideNav);

            Nav.items.map(x => {
              this.count = 1;

              if (x.name != "Home") {
                x["isChildrenExist"] = false;
                this.checkArrayModuleNew(x, x);
              } else {
                x["isChildrenExist"] = true;
              }
            });
            setTimeout(() => {
              loader.hide();
            }, 2500);

            // this.SideNav=this.array_new_module
            console.log("this.modules :", Nav.items);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions(["setCurrentSideNavRoute"]),
    toggleSidebar: function() {
      this.Sidebar = !this.Sidebar;
      if (!this.Sidebar) {
        this.SideNav.map((x, _index) => {
          x.isCollapsed = false;
        });
      }
    },
    onsidebar() {
      if (this.Sidebar == false) {
        this.toggleSidebar();
      }
    },
    onHandleCollapsed(parentNav, index) {
      // console.log("onHandleCollapsed called: source", source);
      console.log("onHandleCollapsed called: index", index);
      console.log("onHandleCollapsed called: parentNav", parentNav);
      console.log("onHandleCollapsed called: SideNav", this.SideNav);
      if (parentNav[index].isCollapsed) {
        parentNav[index].isCollapsed = false;
      } else {
        parentNav.map((x, _index) => {
          if (_index === index) {
            x.isCollapsed = true;
          } else {
            x.isCollapsed = false;
          }
        });
      }
      // console.log("onHandleCollapsed called: parentNav", parentNav);
      // this.$forceUpdate();
    },
    checkChildrens(index, Nav) {
      return checkParentId(Nav);
    },
    checkNavPermissions: function(Nav, direct_sale_flag, module_id, nav1) {
      let permissions = Nav.permissions;
      // let module_id = Nav.module_id;
      // console.log("Nav :", nav1);
      // console.log("module_id :", module_id);
      //if user role is not any of the main 5, check module id in the local storage with module id
      return checkAccessController(module_id);

      // console.log("permissions :", permissions);
      // if (!this.secureStore.get("USINFO")) return false;
      // else {
      //   if (direct_sale_flag) {
      //     const { cine_direct_sale } = this.secureStore.get("USINFO");
      //     if (cine_direct_sale == "Y") {
      //       return false;
      //     }
      //   }
      //   // console.log('this.secureStore.get("USINFO") :', this.secureStore.get("USINFO"));
      //   const { role_name } = this.secureStore.get("USINFO");
      //   return permissions && permissions.length > 0
      //     ? permissions.filter(role => role.trim() === role_name.trim())
      //         .length > 0
      //     : true;

      //   // console.log("role.trim() :", role.trim());
      // }
      // // return true;
    },
    goHome() {
      this.$router.replace("/");
    }
  }
};
</script>

<style>
.sidebar-nav .show {
  border-bottom: 1px solid white;
}
</style>



// WEBPACK FOOTER //
// src/components/Containers/sidebar.vue